import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-order-delivery-time',
  templateUrl: './ui-order-delivery-time.component.html',
  styleUrls: ['./ui-order-delivery-time.component.scss']
})
export class UiOrderDeliveryTimeComponent implements OnInit {
  @Input() deliveryDate: string;
  @Input() deliveryTime: string;

  constructor() {
  }

  ngOnInit() {
  }

}
